const packageJson = require('../../package.json');
const config = require("../../secrets/config");
const env = process.env.NODE_ENV || 'development';
console.log("environment", env);
module.exports = {
  title: packageJson.title,
  version: packageJson.version,
  settings: {
    dense: false,
    footer: false,
    navbar: {
      show: true,
      dense: false,
      logo: true,
    }
  },
  URLS: {
    i5Scheduler: config.URLS.i5Scheduler,
    tokenService: config.URLS.tokenService,
    userManagement: config.URLS.userManagement
  },
  eventyTypesList: config.eventyTypesList,
  loginConfig: config.loginConfig,
  MICROSOFT: {
    loginRequestScopes: {
      scopes: config.MICROSOFT.loginRequestScopes.scopes
    },
    graphConfig: {
      graphMeEndpoint: config.MICROSOFT.graphConfig.graphMeEndpoint,
      graphProfilePicEndPointExternal: config.MICROSOFT.graphConfig.graphProfilePicEndPointExternal,
      graphProfilePicEndPointInternal: config.MICROSOFT.graphConfig.graphProfilePicEndPointInternal
    },
    MSAuthConfig: {
      auth: {
        clientId: config.MICROSOFT.MSAuthConfig.auth.clientId, //You will need to change this
        authority: config.MICROSOFT.MSAuthConfig.auth.authority,
        redirectUri: config.MICROSOFT.MSAuthConfig.auth.redirectUri //You will need to change this
        // "http://localhost:80/"
        // https://dev-gse.incus5.com/
      }
    }
  }
}